/**
 * CSV export of a list the user is already looking at. Exporting the *visible*
 * rows is deliberate: it is the filtered, searched list they built, and it needs
 * no export endpoint, no job, and no server round trip.
 */

/** RFC 4180 quoting: wrap when the value contains a delimiter, quote, or newline. */
export function csvCell(value: string): string {
  return /[",\r\n]/u.test(value) ? `"${value.replaceAll('"', '""')}"` : value;
}

export function toCsv(rows: readonly (readonly string[])[]): string {
  return rows.map((row) => row.map(csvCell).join(",")).join("\r\n");
}

/**
 * Hand the browser a file. Object URLs and `download` are the only way to save
 * a client-generated file, and jsdom implements neither, so this is a seam the
 * tests replace.
 */
export const fileDownload = {
  save(filename: string, content: string, type = "text/csv;charset=utf-8"): void {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.append(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(url);
  },
};
